export default {
  stockItemLinks: [],
  stockItemLink: undefined,
};
